import { useState } from "react";
import {
  TextField,
  Button,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Box,
  Divider,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material"; // Importing icons
import Logo from "./../image/ClearVault_logo.png";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import axios from "axios";
const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // State to toggle confirm password visibility
  const navigate = useNavigate();
  const location = useLocation();

  const path = location.pathname;
  const splitPath = path.split("/reset-password/")[1];

  console.log(splitPath, "splitPath");

  const validatePassword = (password) => {
    const strongPasswordRegex =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;
    return strongPasswordRegex.test(password);
  };

  const handleResetPassword = async () => {
    if (!newPassword || !confirmPassword) {
      setError("Both password fields are required.");
      return;
    }

    if (!validatePassword(newPassword)) {
      setError(
        "Password must be at least 8 characters long and contain at least one letter, one number, and one special character"
      );
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);
    setMessage("");
    setError("");
    setSubmitted(false);
    const path = window.location.href;
    console.log(path);

    const params = new URL(path);
    const uidb64 = params.searchParams.get("uidb64");
    const token = params.searchParams.get("token");

    try {
      const res = await axios.post(`/cvault/reset-password/${uidb64}/${token}`, {
        new_password: confirmPassword,
      });
      setMessage("Your password has been successfully reset.");
      setSubmitted(true);
    } catch (err) {
      console.log(err, "errrrrrrrrrrrooeo");

      setError(err?.response?.data?.error || err?.response?.data?.detail);
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f8f9fb",
        position: "relative",
        px: 2, // Reduced padding
        py: 1, // Reduced padding
      }}
    >
      <Card
        sx={{ maxWidth: 400, p: 1.5, pb: 0, boxShadow: "none", mt: "auto" }}
      >
        <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
          <img src={Logo} alt="Logo" style={{ width: "100px" }} />
        </Box>
        {!submitted && (
          <>
            <CardHeader
              sx={{ pt: 0, pb: "8px" }}
              title={
                <Typography
                  variant="h6"
                  sx={{ textAlign: "center", fontWeight: "500" }}
                >
                  Reset Your Password
                </Typography>
              }
            />
            {/* <Typography sx={{ color: "#8687A3", fontSize: '0.87rem', textAlign: 'center' }}>
              Please enter your new password below to complete the reset process.
            </Typography> */}
          </>
        )}
        <CardContent sx={{ p: 1.5, pb: 0, pt: 0 }}>
          {!submitted ? (
            <>
              <label className="mb-1 ps-0">
                <h6 className="mb-0 text-sm">New Password</h6>
              </label>

              <TextField
                fullWidth
                variant="outlined"
                type={showPassword ? "text" : "password"} // Toggle password visibility
                margin="normal"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                // helperText={error}
                // error={!!error}
                sx={{
                  marginTop: "0px",
                  "& .MuiOutlinedInput-root": {
                    fontSize: "0.75rem",
                    "& fieldset": {
                      borderColor: "#D0D5DD",
                      borderRadius: "6px",
                      padding: "12px 0px",
                    },
                    "&:hover fieldset": { borderColor: "#D0D5DD" },
                    "&.Mui-focused fieldset": {
                      borderColor: "#667085",
                      borderWidth: "1px",
                    },
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        sx={{ padding: 0 }}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <label className="mb-1 ps-0">
                <h6 className="mb-0 text-sm">Confirm Password</h6>
              </label>

              <TextField
                fullWidth
                variant="outlined"
                type={showConfirmPassword ? "text" : "password"} // Toggle confirm password visibility
                margin="normal"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                helperText={error}
                error={!!error}
                sx={{
                  marginTop: "0px",
                  "& .MuiOutlinedInput-root": {
                    fontSize: "0.75rem",
                    "& fieldset": {
                      borderColor: "#D0D5DD",
                      borderRadius: "4px",
                      padding: "12px 0px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#D0D5DD",
                      borderRadius: "4px",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#667085",
                      borderWidth: "1px",
                      borderRadius: "4px",
                    },
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                        sx={{ padding: 0 }}
                      >
                        {showConfirmPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                onClick={handleResetPassword}
                fullWidth
                variant="contained"
                sx={{
                  marginTop: "16px", // Reduced margin top
                  backgroundColor: "#1A237E",
                  color: "#fff",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#0D1B64", // Custom hover color
                  },
                }}
                type="submit"
                disabled={loading}
              >
                {loading ? "Resetting..." : "Reset Password"}
              </Button>
            </>
          ) : (
            <Typography sx={{ mt: 2, textAlign: "center", color: "#708090" }}>
              {message}
            </Typography>
          )}
          <Button
            fullWidth
            sx={{
              marginTop: "8px",
              color: "#1A237E",
              textTransform: "none",
            }}
            type="button"
            onClick={() => navigate("/login")}
          >
            Back to Login
          </Button>
        </CardContent>
      </Card>
      {/* <Box sx={{ mt: "auto", width: "100%", textAlign: "center", }}>
        <Divider sx={{ mb: 1, mt: 1 }} /> */}
      <footer className="footer mt-auto text-center py-3 w-100">
        <div className="row px-3">
          {" "}
          <small className="ml-4 ml-sm-5 mb-2">
            Copyright &copy; 2025. All rights reserved.
          </small>
        </div>
      </footer>
      {/* </Box> */}
    </Box>
  );
};

export default ResetPassword;
